import React, { Component } from "react";
import "./BrandContent.scss";
import { Link } from "react-router-dom";
import BrandlistMenu from "../../../../components/Brands/BrandlistMenu/BrandlistMenu";
import FormationItem from "../../../../components/FormationItem/FormationItem";
import { getCourseByBrands } from "../../../../api/brands";
import { getBrandById } from "../../../../api/brands";
import PropTypes from "prop-types";
import images from "../../../../ressources/images";
import { withTranslation } from "react-i18next";

export class BrandFormation extends Component {
  static propTypes = {
    logo: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      whoActive: "formations",
      dataFormation: [],
      idFormation: 0,
      dataBrand: [],
      lng: this.props.i18n.language,
      loadImage: false,
    };
  }

  UNSAFE_componentWillMount() {
    let brandId = document.location.href.split("/");
    brandId = brandId[brandId.length - 1];
    this.setState({ idFormation: brandId });
  }

  componentDidMount() {
    this.getAllCourseByBrands();
    this.getBrandByIdFront();
  }

  componentDidUpdate() {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this.getAllCourseByBrands();
      this.getBrandByIdFront();
    }
  }

  /**
   * Récupere toutes les marques disponible
   */
  getAllCourseByBrands = () => {
    const { idFormation } = this.state;
    this.setState({ dataFormation: [] });
    getCourseByBrands(idFormation).then((data) => {
      this.setState({ dataFormation: data });
    });
  };

  /**
   * Récupere la marque par id
   */
  getBrandByIdFront = () => {
    const { idFormation } = this.state;
    this.setState({ dataBrand: [] });
    getBrandById(idFormation).then((data) => {
      this.setState({ dataBrand: data, loadImage: true });
    });
  };

  render() {
    const { t } = this.props;
    const { dataBrand, dataFormation, idFormation, whoActive, loadImage } =
      this.state;
    return (
      <>
        <div className="white--wrapper">
          <div>
            <Link
              className="brandlist_backlink"
              to={{
                pathname: "/brands",
                state: { transitionName: "slide_in" },
              }}
            >
              <img src={images.arrow_left_black} alt="" />
            </Link>
            <div className="brandlist_content default-layout--min-height flex flex-col">
              <div className="flex-row-center">
                <div className="brand_logo">
                  {loadImage && (
                    <img
                      className="brandlist_logo"
                      src={dataBrand.logoNoir}
                      alt="logo"
                    />
                  )}
                </div>
              </div>
              <BrandlistMenu whoActive={whoActive} brandId={idFormation} />
              <div className="brand_contentlist">
                {dataFormation.length > 0 ? (
                  dataFormation.map((course, index) => (
                    <FormationItem
                      key={index}
                      brand={course.brand}
                      image={course.picture}
                      title={course.title}
                      formation={course.type}
                      time={course.time}
                      points={course.points}
                      idFormation={course.id}
                      pourcent={course.pourcent}
                    />
                  ))
                ) : (
                  <div className="back_soon">
                    <div>{t("teacher_missing")}</div>
                    <div>{t("come_back_soon")} </div>
                    <span className="smile" role="img" aria-label="">
                      &#128578;
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(BrandFormation);
